<div class="page-content-small page-fill d-flex flex-row" style="position: relative; overflow: hidden">
    <div class="flex-fill d-flex">
        <div class="m-1 grid-fill" *ngIf="messages">
            <dx-data-grid
                #dataGrid
                keyExpr="id"
                [dataSource]="messages"
                [columnAutoWidth]="false"
                [showBorders]="true"
                [wordWrapEnabled]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onSelectionChanged)="selectionChange($event)"
                (onCellDblClick)="rowDoubleClick($event)"
                (onOptionChanged)="onOptionChanged($event)"
                (onContentReady)="onContentReady($event)"
            >
                <dxi-column dataField="name" width="150"></dxi-column>
                <dxi-column dataField="message" width="400"></dxi-column>
                <dxi-column dataField="message2" width="400"></dxi-column>
                <dxi-column dataField="isChannelPartnerMessage" caption="Channel Partner" width="100"></dxi-column>
                <dxi-column dataField="isDefaultMessage" caption="Default Message" width="100"></dxi-column>
                <dxi-column dataField="isNoPrePayMessage" caption="No PrePay Message" width="100"></dxi-column>
                <dxi-column dataField="created" caption="Created" type="date" width="100"></dxi-column>
                <dxi-column dataField="archived" caption="Archived" type="date" width="100"></dxi-column>
                <dxi-column width="50"></dxi-column>

                <div *dxTemplate="let item of 'columnTemplate'">
                    <div style="font-weight: bold">{{ item.data.shipToLocation }}</div>
                    <div>{{ item.data.shipToAddress1 }}</div>
                    <div [hidden]="!item.data.shipToAddress2">{{ item.data.shipToAddress2 }}</div>
                    <div>{{ item.data.shipToCity }}, {{ item.data.shipToState }} {{ item.data.shipToZip }} {{ item.data.shipToCountry }}</div>
                </div>

                <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="confirmations-messages-grid"></dxo-state-storing>
                <dxo-selection [mode]="'multiple'"></dxo-selection>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button (click)="open(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1" class="btn btn-success">
                        Open
                    </button>
                    <button (click)="open()" class="btn btn-secondary ms-2">New</button>
                    <button
                        (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                        class="btn btn-danger ms-4"
                    >
                        Delete
                    </button>
                    <button
                        (click)="toggleArchived(dataGrid.instance.getSelectedRowsData())"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                        class="btn btn-secondary ms-4"
                    >
                        Toggle Archived
                    </button>
                    <button (click)="toggleShowArchived()" class="btn btn-warning ms-4">{{ filter.showArchived ? 'Hide Archived' : 'Show Archived' }}</button>
                    <button (click)="previewOpen = !previewOpen" class="btn ms-4" [class.btn-success]="!previewOpen" [class.btn-outline-success]="previewOpen">
                        <i class="fa fa-eye me-1"></i> Preview
                    </button>
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                    <span *ngIf="messages" class="me-3"
                        ><strong
                            >{{ dataGrid.instance.totalCount() + ' items' }}
                            {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                        </strong></span
                    >
                </div>
            </dx-data-grid>
        </div>
    </div>
    <div class="preview-flyout" [class.open]="previewOpen">
        <div class="d-flex align-items-center mb-3">
            <h3 class="mb-0 flex-fill">Preview</h3>
            <button class="btn btn-sm btn-outline-secondary" (click)="previewOpen = false" title="Close preview">&#x2715;</button>
        </div>
        <app-portal-confirmation [confirmationInfo]="confirmationInfo" [displayMode]="true" style="margin: 0rem !important"> </app-portal-confirmation>
    </div>
</div>
